<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Valentino's Love-Child</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="aboutAuthorPage" id="ata01"><a id="page05"><h2 class="aboutAuthorHead"><span class="bold"><span>All about the author…<br/>
<em class="italic"><span>Lucy Monroe</span></em></span></span></h2><p class="aboutAuthorText"><span>Award-winning and bestselling author <span class="bold"><span>LUCY MONROE</span></span> sold her first book in September of 2002 to the Harlequin Presents<sup>®</sup> line. That book represented a dream that had been burning in her heart for years…the dream to share her stories with readers who love romance as much as she does. Since then she has sold more than thirty books to three publishers and has hit national bestseller lists in the U.S. and England. But since selling that first book, the reader letters she receives are what have touched her most deeply. Her most important goal with every book is to touch a reader’s heart, and when she hears she’s done that it makes every night spent writing into the wee hours of morning worth it.</span></p><p class="aboutAuthorText"><span>She started reading Harlequin Presents<sup>®</sup> books very young and discovered a heroic type of man between the covers of those books—an honorable man, capable of faithfulness and sacrifice for the people he loves. Now married to what she terms her “alpha male at the end of a book,” Lucy believes there is a lot more reality to the fantasy stories she writes than most people give credit for. She believes in happy endings that are really marvelous beginnings, and that’s why she writes them. She hopes her books help readers believe a little, too…just like romance did for her so many years ago.</span></p><p class="aboutAuthorText"><span>She really does love to hear from readers and responds to every e-mail. You can reach her by e-mailing lucymonroe@lucymonroe.com.</span></p></a><a id="page06"></a></div>
<a id="page06">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// valentinoslovechild_ata01.vue?60419cb9